import { ChangeDetectorRef, Component, ElementRef, HostBinding, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { LayoutService } from '../../services/layout.service';
import icBookmarks from '@iconify/icons-ic/twotone-bookmarks';
import emojioneUS from '@iconify/icons-emojione/flag-for-flag-united-states';
import emojioneDE from '@iconify/icons-emojione/flag-for-flag-germany';
import icMenu from '@iconify/icons-ic/twotone-menu';
import { ConfigService } from '../../services/config.service';
import { map } from 'rxjs/operators';
import icPersonAdd from '@iconify/icons-ic/twotone-person-add';
import icAssignmentTurnedIn from '@iconify/icons-ic/twotone-assignment-turned-in';
import icBallot from '@iconify/icons-ic/twotone-ballot';
import icDescription from '@iconify/icons-ic/twotone-description';
import icAssignment from '@iconify/icons-ic/twotone-assignment';
import icReceipt from '@iconify/icons-ic/twotone-receipt';
import icDoneAll from '@iconify/icons-ic/twotone-done-all';
import { NavigationService } from '../../services/navigation.service';
import icArrowDropDown from '@iconify/icons-ic/twotone-arrow-drop-down';
import { PopoverService } from '../../components/popover/popover.service';
import { MegaMenuComponent } from '../../components/mega-menu/mega-menu.component';
import icSearch from '@iconify/icons-ic/twotone-search';
import { ToolbarAgGridComponent } from './toolbar-ag-grid/toolbar-ag-grid.component';
import { RoleGuardService as RoleGuard } from '../../../app/pages/auth/helpers/role-guard.service';
import { APP_VERSION } from '../../../app/version';
import { NotificationService } from '../../../app/helpers/services/notification.service';
import { ImpersonationService } from '../../../app/helpers/services/impersonation.service';
import { MatDialog } from '@angular/material/dialog';
import { AssignTaskDialogComponent } from '../../../app/pages/tasks/assign-task-dialog.component';

@Component({
    selector: 'vex-toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss'],
    standalone: false
})
export class ToolbarComponent implements OnInit {

  readonly unreadCount$ = this.notificationService.unreadCount$;

  @Input() mobileQuery: boolean;

  @Input()
  @HostBinding('class.shadow-b')
  hasShadow: boolean;
  @ViewChild('themeBtn', { static: true, read: ElementRef }) originRef: ElementRef;

  private userRole: string;
  navigationItems: any[] = [];

  isHorizontalLayout$ = this.configService.config$.pipe(map(config => config.layout === 'horizontal'));
  isVerticalLayout$ = this.configService.config$.pipe(map(config => config.layout === 'vertical'));
  isNavbarInToolbar$ = this.configService.config$.pipe(map(config => config.navbar.position === 'in-toolbar'));
  isNavbarBelowToolbar$ = this.configService.config$.pipe(map(config => config.navbar.position === 'below-toolbar'));

  icSearch = icSearch;
  icBookmarks = icBookmarks;
  emojioneUS = emojioneUS;
  emojioneDE = emojioneDE;
  icMenu = icMenu;
  icPersonAdd = icPersonAdd;
  icAssignmentTurnedIn = icAssignmentTurnedIn;
  icBallot = icBallot;
  icDescription = icDescription;
  icAssignment = icAssignment;
  icReceipt = icReceipt;
  icDoneAll = icDoneAll;
  icArrowDropDown = icArrowDropDown;
  dropdownOpen: boolean;
  appVersion = APP_VERSION;
  constructor(private layoutService: LayoutService,
              private configService: ConfigService,
              private navigationService: NavigationService,
              private popoverService: PopoverService,
              private cd: ChangeDetectorRef,
              private roleGuard: RoleGuard,
              private router: Router,
              private notificationService: NotificationService,
              readonly impersonationService: ImpersonationService,
              private dialog: MatDialog) {
    this.userRole = this.roleGuard.getRole();
    // Filter once and cache
    this.navigationItems = this.filterItemsByRole(this.navigationService.items);
  }

  private filterItemsByRole(items: any[]): any[] {
    if (!items) return [];
    return items?.filter(item => {
      if (!item?.role || item?.role?.length === 0) return true;
      return item?.role?.includes(this?.userRole);
    }).map(item => {
      if (item?.children && item.children?.length > 0) {
        return { ...item, children: this.filterItemsByRole(item.children) };
      }
      return item;
    });
  }

  ngOnInit() {
    this.notificationService.startPolling();
  }

  openQuickpanel() {
    this.layoutService.openQuickpanel();
  }

  openSidenav() {
    this.layoutService.openSidenav();
  }

  openMegaMenu(origin: ElementRef | HTMLElement) {
    this.popoverService.open({
      content: MegaMenuComponent,
      origin,
      position: [
        {
          originX: 'start',
          originY: 'bottom',
          overlayX: 'start',
          overlayY: 'top'
        },
        {
          originX: 'end',
          originY: 'bottom',
          overlayX: 'end',
          overlayY: 'top',
        },
      ]
    });
  }

  openSearch() {
    this.layoutService.openSearch();
  }

  openConfigPanel() {
    this.layoutService.openConfigpanel();
  }

  openThemeDialog() {
    this.dropdownOpen = true;
    this.cd.markForCheck();

    const popoverRef = this.popoverService.open({
      content: ToolbarAgGridComponent,
      origin: this.originRef,
      offsetY: 12,
      position: [
        {
          originX: 'center',
          originY: 'top',
          overlayX: 'center',
          overlayY: 'bottom'
        },
        {
          originX: 'end',
          originY: 'bottom',
          overlayX: 'end',
          overlayY: 'top',
        },
      ]
    });

    popoverRef.afterClosed$.subscribe(() => {
      this.dropdownOpen = false;
      this.cd.markForCheck();
    });
  }

  toggleToolbar() {
    const anyWindow = window as any;
    const toggleFn = anyWindow.togglePageToolbar;
    if (typeof toggleFn === 'function') toggleFn();
  }

  navigateToNotifications() {
    this.router.navigate(['/notifications']);
  }

  openAssignTaskDialog(): void {
    this.dialog.open(AssignTaskDialogComponent, {
      width: '520px',
      maxWidth: '95vw',
      panelClass: 'assign-task-panel',
    });
  }
}
